module.exports = __webpack_public_path__ + "img/4.c33cf869.jpg";